export const trackingEventExperiments = "experiment";
export const trackingEventActionsForExperiments = {
    exposure: "exposure",
    goal: "goal",
};
//# sourceMappingURL=experiments.js.map